// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicy_page__fjtRo","header":"PrivacyPolicy_header__dgkrR","tabs":"PrivacyPolicy_tabs__d3CQi"};